import axios from '../../../../axios';

import {
  PERSONS,
  DOCUMENT_TYPE,
  DELETE_DOCUMENT,
  CREATE_DOCUMENTS,
  DOCUMENT_DETAILS,
  LIST_ALL_DOCUMENTS,
  DOCUMENT_CATEGORIES,
  DOCUMENTS_FULL_TEXT_SEARCH,
  baseDocumentUrl,
  FAVORITE_FILTERS,
  DELETE_FAVORITE_FILTER,
  CREATE_FAVORITE_FILTER,
  TASK_STATUS,
  LIST_FOLDER_TREE,
  FOLDERS,
  LIST_FILE_FORMATS,
  POSTBOX_CREDENTIALS,
} from 'utils/apiEndPoints';

export const createDocumentService = async (payload) => {
  try {
    const { data } = await axios.post(CREATE_DOCUMENTS, payload);

    return data;
  } catch (error) {
    throw error;
  }
};

export const filterCriteriaService = async (filters) => {
  try {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, values]) => {
      values.forEach((value) => {
        params.append(key, value);
      });
    });

    const { data } = await axios.get(
      `${baseDocumentUrl}/filter-criteria/?${params.toString()}`,
    );

    return data;
  } catch (error) {
    throw error;
  }
};

export const documentDetailsService = async (id) => {
  try {
    const { data } = await axios.get(DOCUMENT_DETAILS + `${id}`);

    return data;
  } catch (error) {
    throw error;
  }
};

export const documentFullTextSearchService = async (search_query) => {
  try {
    const { data } = await axios.get(DOCUMENTS_FULL_TEXT_SEARCH + search_query);

    return data;
  } catch (error) {
    throw error;
  }
};

export const getDocumentsService = async (url = LIST_ALL_DOCUMENTS) => {
  try {
    const { data } = await axios.get(url);

    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteDocumentService = async (id) => {
  try {
    const response = await axios.delete(DELETE_DOCUMENT + `${id}`);

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDocumentCategoryService = async () => {
  try {
    const { data } = await axios.get(DOCUMENT_CATEGORIES);

    return data;
  } catch (error) {
    throw error;
  }
};

export const getDocumentTypeService = async () => {
  try {
    const { data } = await axios.get(DOCUMENT_TYPE);

    return data;
  } catch (error) {
    throw error;
  }
};

export const getPersonsService = async () => {
  try {
    const { data } = await axios.get(PERSONS);

    return data;
  } catch (error) {
    throw error;
  }
};

export const getFavoriteFiltersService = async () => {
  try {
    const { data } = await axios.get(FAVORITE_FILTERS);

    return data;
  } catch (error) {
    throw error;
  }
};

export const createFavoriteFilterService = async (payload) => {
  try {
    const { data } = await axios.post(CREATE_FAVORITE_FILTER, payload);

    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteFavoriteFilterService = async (id) => {
  try {
    const response = await axios.delete(DELETE_FAVORITE_FILTER + `${id}`);

    return response;
  } catch (error) {
    throw error;
  }
};

export const documentUploadStatus = async (taskId) => {
  try {
    const response = await axios.get(TASK_STATUS + `${taskId}/`);
    const { status } = response.data;

    return status;
  } catch (error) {
    throw error;
  }
};

export const listFolderTree = async () => {
  try {
    const data = await axios.get(LIST_FOLDER_TREE);

    return data;
  } catch (error) {
    throw error;
  }
};

export const createFolder = async ({ name, parent = null }) => {
  try {
    const data = await axios.post(FOLDERS, {
      name,
      parent,
      is_root: false,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const renameFolder = async ({ newName, folderId }) => {
  try {
    const response = await axios.patch(`${FOLDERS}/${folderId}`, {
      name: newName.trim(),
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteFolder = async ({ folderId }) => {
  try {
    const data = await axios.delete(`${FOLDERS}/${folderId}`);

    return data;
  } catch (error) {
    throw error;
  }
};

export const moveDocument = async ({ documentId, newFolderId }) => {
  try {
    const data = await axios.patch(`${baseDocumentUrl}/${documentId}`, {
      folder: newFolderId,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const listFileFormats = async () => {
  try {
    const data = await axios.get(LIST_FILE_FORMATS);

    return data.data;
  } catch (error) {
    throw error;
  }
};

export const listPostboxCredentials = async () => {
  const response = await axios.get(POSTBOX_CREDENTIALS);
  return response.data;
};

export const createPostboxCredential = async (payload) => {
  const response = await axios.post(POSTBOX_CREDENTIALS, payload);
  return response.data;
};

export const updatePostboxCredential = async (id, payload) => {
  const response = await axios.patch(`${POSTBOX_CREDENTIALS}/${id}`, payload);
  return response.data;
};

export const deletePostboxCredential = async (id) => {
  return axios.delete(`${POSTBOX_CREDENTIALS}/${id}`);
};

export const extractPostboxDocuments = async (
  id,
  otp = null,
  challengeToken = null,
) => {
  const payload = {};
  if (otp) payload.otp = otp;
  if (challengeToken) payload.challenge_token = challengeToken;
  const response = await axios.post(
    `${POSTBOX_CREDENTIALS}/${id}/extract`,
    payload,
  );
  return response.data;
};
